import { ValidationErrors } from "@angular/forms";
import { MatSelectChange } from "@angular/material/select";

import { FieldSet } from "./index";

export interface Option {
    id: string | number;
    value: string;
}

export interface IFormBase<T> {
    value: T|undefined;
    key: string;
    name: string;
    label: string;
    required: boolean | string;
    search: boolean;
    type: string;
    options: Option[];
    defaultOption: string;
    selectOptions: string;
    multiSelect: boolean;
    countOfSelect?: number;
    apiDependencyFields?: string[],
    dateAllowed?: boolean,
    dependency ?: string[],
    reloadDataOnChange?: boolean,
    dependsOn?: string
}

interface DateDetail {
    month: string;
    year: number;
}

export interface FromToTimeRange {
    from: DateDetail;
    to: DateDetail;
}

export interface StartEndTimeRange {
    start: Date;
    end: Date;
}

export interface FormFieldEvent {
    name: string;
    value: string | string[] | StartEndTimeRange;
    selectionChangeEvent?: null | MatSelectChange;
    errors?: ValidationErrors | null;
}

export interface FormData {
    description?: boolean;
    fieldData: FieldSet[];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formValues: {[key: string]: any};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    deleteReport?: any;
}

export interface FieldSetValidators {
    fieldSetName: string;
    minRequired: number;
    fieldNames: string[];
}

export interface SelectEvent {
    name: string;
    value: string | string[];
    selectionChangeEvent: null | MatSelectChange;
}

export enum FieldType {
    SELECT = 'select',
    TEXT = 'text',
    DATE =  'date',
    PERIOD = 'period'
}
